var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusExtraLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148610",
    "data-name": "Rectangle 148610",
    width: 30,
    height: 30,
    transform: "translate(797 583)",
    fill: "#442323"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(-797 -583)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11741",
    "data-name": "Group 11741",
    transform: "translate(0.164 50.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11740",
    "data-name": "Group 11740",
    transform: "translate(799.836 535.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8428",
    "data-name": "Path 8428",
    d: "M19244.645-13001.445a.9.9,0,0,1-.9-.9v-24a.9.9,0,0,1,.9-.9.9.9,0,0,1,.9.9v24A.9.9,0,0,1,19244.645-13001.445Z",
    transform: "translate(-19232.645 13026.346)",
    fill: "#ff411a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8429",
    "data-name": "Path 8429",
    d: "M0,24.9A.9.9,0,0,1-.9,24V0A.9.9,0,0,1,0-.9.9.9,0,0,1,.9,0V24A.9.9,0,0,1,0,24.9Z",
    transform: "translate(0 12) rotate(-90)",
    fill: "#ff411a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusExtraLarge);
export default __webpack_public_path__ + "static/media/plus-extra-large.7342f26d.svg";
export { ForwardRef as ReactComponent };